/* @flow weak */
import React from 'react';
import enumerate from 'lib/enumerate';
import Link from 'components/Link.jsx';
import LinkSmsPhoneInputBox from 'user/components/LinkSmsPhoneInputBox.jsx';
import LinkSmsVerificationCodeBox from 'user/components/LinkSmsVerificationCodeBox.jsx';
import ToastActions from 'actions/ToastActions';
import Subscription from 'entities/Subscription';

const STATUS = enumerate([
  'ASK_PHONE',
  'ASK_CODE',
]);

const LinkSmsDevicePage = React.createClass({
  propTypes: {
    /* return linked device */
    onDone: React.PropTypes.func.isRequired,
    /* optional - skip asking for the phone, ask for code directly */
    token: React.PropTypes.string,
    /* optional - enable skipping */
    onSkip: React.PropTypes.func,
    /* optional - show modal close button */
    closable: React.PropTypes.bool,
    /* optional - group code this is required for instantResend  */
    groupCode: React.PropTypes.string,
    /* optional - address eg (sms://+14156152427) is required for instantResend  */
    address: React.PropTypes.string,
    /* optional - when true will resent code to mobile directly */
    instantResend: React.PropTypes.bool,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  getInitialState() {
    return {
      status: this.props.token ? STATUS.ASK_CODE : STATUS.ASK_PHONE,
      token: this.props.token || null,
    };
  },

  onDeviceLinked() {
    this.props.onDone(...arguments);
  },

  onPhoneNumberSubmit(result) {
    this.setState({
      status: STATUS.ASK_CODE,
      token: result.token,
      phoneNumber: result.phoneNumber,
    });
  },

  onResend() {
    if (this.props.instantResend) {
      this.resendSms();
    } else {
      this.setState(this.getInitialState());
    }
  },

  resendSms() {
    const onSuccess = (response) => {
      ToastActions.showSuccessToast('Code resent');
      this.setState({ token: response.token });
    };

    const onError = () => {
      ToastActions.showDefaultErrorToast();
    };

    Subscription
      .initiateDeviceSubscription(this.props.groupCode, this.props.address)
      .then(onSuccess, onError);
  },

  renderAskConfirmationCode() {
    let footer = null;
    if (this.props.onSkip) {
      footer = (
        <span>
          or <Link onClick={this.props.onSkip}>skip this step</Link>
        </span>
      );
    }

    return (
      <LinkSmsVerificationCodeBox
        closable={this.props.closable}
        onDone={this.onDeviceLinked}
        token={this.state.token}
        phoneNumber={this.state.phoneNumber}
        onResend={this.onResend}
        footer={footer}
      />
    );
  },

  renderAskPhoneNumber() {
    let footer = null;
    if (this.props.onSkip) {
      footer = (
        <span>
          Don’t want to connect a phone? <Link onClick={this.props.onSkip}>Skip this step</Link>
        </span>
      );
    }

    return (
      <LinkSmsPhoneInputBox
        onRequestHide={this.props.onRequestHide}
        closable={this.props.closable}
        footer={footer}
        onDone={this.onPhoneNumberSubmit}
      />
    );
  },

  render() {
    return {
      [STATUS.ASK_PHONE]: this.renderAskPhoneNumber,
      [STATUS.ASK_CODE]: this.renderAskConfirmationCode,
    }[this.state.status]();
  },
});

export default LinkSmsDevicePage;



// WEBPACK FOOTER //
// ./src/user/components/LinkSmsDevicePage.jsx